import { InjectionToken } from '@angular/core';

import { environment } from '@rpgc-ai/environments';

export interface UrlRewriteRule {
  target: string;
  prefix?: string;
}

export const CDN_REPLACE_CONFIG = {
  'imagedelivery.net': {
    target: environment.IMG_URL,
    prefix: '/cdn-cgi/imagedelivery',
  },
  'store.caichat.ai': {
    target: environment.VIDEO_URL,
  },
};

export const CDN_REPLACE_TOKEN = new InjectionToken<Record<string, UrlRewriteRule>>('URL_REWRITE_CONFIG');
